<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
const isRtl = () =>
  global.Utils &&
  typeof global.Utils.getHtmlDirection === 'function' &&
  global.Utils.getHtmlDirection() === 'rtl'

export default {
  name: 'Slider',
  props: {
    selector: {
      type: String,
      defaultValue: 'non-exists-element'
    },
    slidesToShow: {
      type: Number,
      defaultValue: 1
    },
    slidesToScroll: {
      type: Number,
      defaultValue: 1
    },
    adaptiveHeight: {
      type: Boolean,
      defaultValue: false
    },
    dots: {
      type: Boolean,
      default: true
    },
    responsiveInfinite: {
      type: Boolean,
      default: true
    },
    selectedRoom: {
      type: Number,
      default: 0
    }
  },
  computed: {
    options() {
      return {
        infinite: true,
        dots: this.dots,
        centerPadding: '15px',
        arrows: true,
        rows: 0,
        rtl: isRtl(),
        adaptiveHeight: this.adaptiveHeight,
        slidesToShow: this.slidesToShow,
        slidesToScroll: this.slidesToScroll,
        initialSlide: this.selectedRoom,
        responsive: [
          {
            breakpoint: 1200,
            settings: { unslick: true }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: '20px',
              infinite: this.responsiveInfinite,
              slidesToShow: this.slidesToShow
            }
          }
        ]
      }
    }
  },
  mounted: function () {
    global.$(this.selector).slick(this.options)
  },
  beforeUpdate: function () {
    global.$(this.selector).slick('unslick')
  },
  updated: function () {
    global.$(this.selector).slick(this.options)
  }
}
</script>
